import React from 'react';
import { sortRowsByAccount } from '../../../services/MatchingService';
import { formatCurrency } from './bankFormat';

// The kontering drawn as the verifikat slip it will become — account bold,
// name muted, belopp right, dashed receipt separators. This is the hero of
// a booking proposal: the user reads the outcome, not a data table.
// `dense` is the same slip at evidence size (historical examples).
export default function KonteringSlip({ rows, dense = false }) {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    return (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden', background: '#fff', marginTop: dense ? 8 : 14 }}>
            {sortRowsByAccount(rows).map((row, index) => {
                const debit = parseFloat(row.debit) || 0;
                const credit = parseFloat(row.credit) || 0;
                return (
                    <div
                        key={`${row.account_number}-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: 10,
                            padding: dense ? '6px 12px' : '9px 14px',
                            borderTop: index > 0 ? '1px dashed #e5e7eb' : 'none',
                        }}
                    >
                        <span style={{ fontWeight: 600, fontSize: dense ? 12 : 13, color: '#111827', fontVariantNumeric: 'tabular-nums' }}>
                            {row.account_number}
                        </span>
                        <span style={{ fontSize: dense ? 12 : 12.5, color: '#6b7280', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {row.account_name || ''}
                        </span>
                        <span style={{ fontSize: dense ? 12 : 12.5, color: '#374151', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                            {debit > 0 ? `Debet ${formatCurrency(debit)}` : `Kredit ${formatCurrency(credit)}`}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
